<entity-management-layout
  *ngIf="payorDropdowns !== undefined"
  (saveClicked)="onSaveClicked()"
  [saveDisabled]="!payorPlanPermissions.canManage"
  (cancelClicked)="navigateBack()"
>
  <div id="top" title class="flex justify-between">
    <h1>{{ title }}</h1>
    <div class="self-end mt-[1rem]">
      Jump to:
      <a (click)="navigateToSection('options-and-modifiers')"
        >Options & Modifiers</a
      >
    </div>
  </div>
  <form content [formGroup]="payorForm">
    <div class="flex justify-between">
      <h3 id="service-sets" class="font-bold pt-6 text-dark_blue">General</h3>
    </div>
    <hr
      class="mt-5 mb-7 text-dark_gray border-black border-[1px] bg-black opacity-100 h-[3px]"
    />
    <div class="flex flex-row mb-8" *ngIf="payor?.id">
      <thera-dropdown
        class="w-1/3 pr-5"
        [options]="statusDropdown"
        [label]="'Status'"
        [formGroup]="payorForm"
        (optionSelected)="statusChanged($event)"
        [controlName]="'status'"
      ></thera-dropdown>
    </div>
    <div class="flex flex-row justify-between">
      <app-input
        class="w-1/3 pr-5"
        formControlName="payorname"
        label="Payor Plan Name"
      >
      </app-input>
      <thera-dropdown 
        class="w-1/3 pr-5"
        [options]="payorDropdowns.corpPayorType"
        [required]="true"
        [label]="'Payor Type'"
        [formGroup]="payorForm"
        [controlName]="'payortypeid'"
        [isDisabled] = "dropdownDisabled"
      ></thera-dropdown>
      <app-input
        class="w-1/3 pr-5"
        [maxLength]="20"
        formControlName="abbreviation"
        label="Abbreviation"
      >
      </app-input>
    </div>
    <hr class="mt-5 mb-7 text-dark_gray opacity-50" />

    <div class="flex flex-row pb-4">
      <app-input
        class="w-1/3 pr-5"
        [required]="true"
        formControlName="address1"
        [label]="'Address Line 1'"
      ></app-input>
      <app-input
        class="w-1/3 pr-5"
        formControlName="address2"
        [label]="'Address Line 2'"
      ></app-input>
    </div>
    <div class="flex flex-row pb-4">
      <app-input
        class="w-1/3 pr-5"
        [required]="true"
        formControlName="city"
        [label]="'City'"
      ></app-input>
      <thera-dropdown
        class="w-1/3 pr-5"
        [datasource]="lookupClient.getStates()"
        [label]="'State'"
        [required]="true"
        [formGroup]="payorForm"
        [controlName]="'stateid'"
        [isDisabled] = "dropdownDisabled"
      ></thera-dropdown>
      <app-input
        class="w-1/3 pr-5"
        [required]="true"
        [maxLength]="5"
        [mask]="'00000'"
        formControlName="zipcode"
        [label]="'Zip'"
      ></app-input>
    </div>
    <div class="flex flex-row">
      <thera-dropdown
        [datasource]="
          lookupClient.getCountiesLookup(payorForm.get('stateid')?.value)
        "
        [formGroup]="payorForm"
        [controlName]="'countyid'"
        label="County"
        [defaultSelection]="payorForm.value?.county"
        [reload$]="reload$"
        [isDisabled]="dropdownDisabled"
      ></thera-dropdown>
    </div>
    <hr class="mt-5 mb-7 text-dark_gray opacity-50" />
    <div class="flex flex-row">
      <app-input
        class="w-1/3 pr-5"
        formControlName="primaryphone"
        [label]="'Phone'"
        [mask]="'(000) 000-0000'"
      ></app-input>
      <app-input
        class="w-1/3 pr-5"
        formControlName="fax"
        [label]="'Fax'"
        [mask]="'(000) 000-0000'"
      ></app-input>
      <app-input
        class="w-1/3 pr-5"
        formControlName="website"
        [label]="'Website'"
      ></app-input>
    </div>

    <div class="flex flex-row">
      <app-input
        class="w-1/3 pr-5"
        formControlName="contactname"
        [label]="'Contact Name'"
      ></app-input>
      <app-input
        class="w-1/3 pr-5"
        formControlName="contactphone"
        [label]="'Contact Phone'"
        [mask]="'(000) 000-0000'"
      ></app-input>
      <app-input
        class="w-1/3 pr-5"
        formControlName="contactemail"
        [label]="'Contact Email'"
      ></app-input>
    </div>
    <div class="flex flex-col w-full">
      <label for="description">Comments</label>
      <textarea
        class="border border-gray-400 rounded-md resize-none w-full"
        rows="5"
        matInput
        name="comments"
        formControlName="comments"
        [disabled]="dropdownDisabled"
      ></textarea>
    </div>
    <div class="flex justify-between">
      <h3
        id="options-and-modifiers"
        class="font-bold pt-6 text-dark_blue text-lg"
      >
        Options & Modifiers
      </h3>
      <div class="flex items-end">
        <a (click)="navigateToSection('top')">Back to Top</a>
      </div>
    </div>
    <hr
      class="mt-5 mb-7 text-dark_gray border-black border-[1px] bg-black opacity-100 h-[3px]"
    />
    <div class="flex flex-row mb-7"></div>
    <form [formGroup]="$any(this.payorForm.get('payorOption'))">
      <div class="flex flex-row">
        <thera-dropdown
          class="w-1/3 pr-5"
          [options]="payorDropdowns.weekDefinition"
          [label]="'Week Definition'"
          [required]="true"
          [formGroup]="$any(this.payorForm.get('payorOption'))"
          [controlName]="'weekdefinitionid'"
          [isDisabled]="dropdownDisabled"
        ></thera-dropdown>
        <div class="flex flex-col w-1/3 pr-5">
          <thera-dropdown
            [options]="[
              {
                id: 1,
                name: 'Yes'
              },
              {
                id: 2,
                name: 'No'
              }
            ]"
            [label]="'CCI Validation'"
            [required]="true"
            (optionSelected)="cciValidationChange($event)"
            [formGroup]="$any(this.payorForm.get('payorOption'))"
            [controlName]="'ccivalidation'"
            [isDisabled]="dropdownDisabled"
          ></thera-dropdown>
          <div
            class="mt-2 -ml-[10px]"
            [class.invisible]="
            !isSelected($any(this.payorForm.get('payorOption')).get('ccivalidation')
                ?.value)
            "
          >
            <mat-checkbox formControlName="xmodifiers"
              >X Modifiers</mat-checkbox
            >
          </div>
        </div>
        <thera-dropdown
          class="w-1/3 pr-5"
          [options]="payorDropdowns.dailyNotes"
          label="Daily Notes"
          [required]="true"
          [formGroup]="$any(this.payorForm.get('payorOption'))"
          controlName="dailynotesid"
          (optionSelected)="dailyNotesChange($event)"
          [isDisabled]="dropdownDisabled"
        ></thera-dropdown>
        <thera-dropdown *ngIf="this.payorForm.get('payorOption')?.get('dailynotesid')
                ?.value=== 1"
          class="w-1/3 pr-5"
          [options]="payorDropdowns.oneTreatmentNotes ? payorDropdowns.oneTreatmentNotes  : []"
          label="Note Preference"
          [formGroup]="$any(this.payorForm.get('payorOption'))"
          controlName="notePreferenceid"
          [isDisabled]="dropdownDisabled"
        ></thera-dropdown>
      </div>
      <div class="flex flex-wrap">
        <div class="mt-2 w-1/3 pr-5">
          <thera-dropdown class="w-1/3 pr-5" [options]="[
                  {
                    id: 1,
                    name: 'Yes'
                  },
                  {
                    id: 2,
                    name: 'No'
                  }
                ]" [label]="'PPS Tracking'" [required]="true" [formGroup]="$any(this.payorForm.get('payorOption'))"
            [controlName]="'ppstracking'" (optionSelected)="ppsTrackingChange($event)" [isDisabled]="dropdownDisabled"></thera-dropdown>
        </div>
      
        <app-input class="mt-2 block w-1/3 pr-5" 
          [required]="true" 
          [maxLength]="3" 
          [minLength]="1" 
          [mask]="'0*'"
          [placeholder]="'Enter a number (1-365 days)'"
          formControlName="rcdayscount" 
          [label]="'Recertification - Intelligent Documentation (in Days)'"
          (valueChange)="intelligentDocConfigValueChange($event)"
          [disabled]="dropdownDisabled">
        </app-input>
      
        <app-input class="mt-2 block w-1/3 pr-5" 
          [required]="true" 
          [maxLength]="3" 
          [minLength]="1"
          [mask]="'0*'"
          [placeholder]="'Enter a number (1-365 days)'"
          formControlName="prdayscount" 
          [label]="'Progress report - Intelligent Documentation (in Days)'"
          (valueChange)="intelligentDocConfigValueChange($event)"
          [disabled]="dropdownDisabled">
        </app-input>
      </div>
      <div
        class="flex justify-between"
        *ngIf="
        isSelected($any(this.payorForm.get('payorOption')).get('ppstracking')?.value)
        "
      >
        <form
          [formGroup]="
            $any(this.payorForm.get('payorOption')?.get('ppsTrackingGroup'))
          "
        >
          <mat-checkbox formControlName="changeomras"
            >Require Change of Therapy OMRAS</mat-checkbox
          >
          <mat-checkbox formControlName="endomras"
            >Require End of Therapy OMRAS</mat-checkbox
          >
          <mat-checkbox formControlName="startomras"
            >Allow Start of Therapy OMRAS</mat-checkbox
          >
        </form>
      </div>
      <mat-error
        class="text-red-600"
        *ngIf="
        isPPsTracking($any(this.payorForm.get('payorOption')).get('ppstracking')?.value) &&
          payorForm
            .get('payorOption')
            ?.get('ppsTrackingGroup')
            ?.hasError('at-least-one-required') &&
          payorForm.get('payorOption')?.touched
        "
      >
        At least one option must be selected
      </mat-error>
      <div class="flex flex-row">
        <thera-dropdown
          class="w-1/3 pr-5"
          [options]="payorDropdowns.lcdRule"
          [label]="'LCD Rule'"
          [formGroup]="$any(this.payorForm.get('payorOption'))"
          [controlName]="'lcdruleid'"
          [isDisabled]="dropdownDisabled"
        ></thera-dropdown>
        <thera-dropdown
          class="w-1/3 pr-5"
          [options]="payorDropdowns.reportCalculationType"
          label="Calculation Type for Reporting"
          [formGroup]="$any(this.payorForm.get('payorOption'))"
          controlName="reportcalculationtypeid"
          [isDisabled]="dropdownDisabled"
        ></thera-dropdown>
      </div>
      <!-- <div class="pt-3 pb-3 w-full" *ngIf="
        payorForm.get('lcdruleid')?.value === '2' ||
        payorForm.get('lcdruleid')?.value === '3'
      ">
      <div class="pb-3">Select the LCD sets associated with this payor.</div>
      <thera-client-side-list class="w-full" [rowData]="payor?.lcdselections || []" [hideGridLines]="false"
        [columnDefs]="lcdColumnConfig" (rowChecked)="rowsSelected($any($event))">
      </thera-client-side-list>
    </div> -->
      <div class="flex flex-col w-full">
        <h3 class="mt-7 block font-bold pt-6 text-dark_blue">Options</h3>
        <div class="flex flex-col bg-polar p-7 pb-10 w-full">
          <div class="flex flex-row">
            <mat-checkbox class="w-1/4" formControlName="sectiongg"
              >Section GG</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="allowconcurrenttherapy"
              >Allow Concurrent Therapy</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="grouptreatment"
              >Group Treatment is Favorable</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="requirepqrs"
              >Require PQRS</mat-checkbox
            >
          </div>
          <div class="flex flex-row">
            <mat-checkbox class="w-1/4" formControlName="authorizationsrequired"
              >Authorization Required</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="concurrenttherapy"
              >Concurrent Therapy is Favorable</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="allowcotreatment"
              >Allow Co-Treatment</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="enforceduration"
              >Enforce Duration & LTG Targets to Equal Certification
              Period</mat-checkbox
            >
          </div>
          <div class="flex flex-row">
            <mat-checkbox class="w-1/4" formControlName="captracking"
              >Cap Tracking</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="mppradjusted"
              >MPPR Adjusted</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="requiremips"
              >Require MIPS</mat-checkbox
            >
          </div>
          <div class="w-1/6 pt-8">
            <thera-dropdown
              [options]="payorDropdowns.levelofCare"
              [label]="'Level of Care'"
              [formGroup]="$any(this.payorForm.get('payorOption'))"
              [required]="true"
              [controlName]="'levelofcareid'"
              [isDisabled]="dropdownDisabled"
            ></thera-dropdown>
          </div>
        </div>
      </div>
    </form>
    <div class="flex flex-col w-full">
      <h3 class="mt-7 block font-bold pt-6 text-dark_blue">
        Telehealth Modifiers
      </h3>
      <form [formGroup]="$any(this.payorForm.get('payorTeleHealth'))">
        <div class="flex flex-col bg-polar p-7 pb-10 w-full">
          <div class="flex flex-row">
            <mat-checkbox class="w-1/3" formControlName="sos02"
              >SOS 02</mat-checkbox
            >
            <mat-checkbox class="w-1/3" formControlName="modifiercr"
              >Modifier CR</mat-checkbox
            >
            <thera-dropdown
              [options]="payorDropdowns.teleHealthSyncCode"
              [label]="'Telehealth Sync Code'"
              [formGroup]="$any(this.payorForm.get('payorTeleHealth'))"
              [controlName]="'telehealthsynccodeid'"
              [isDisabled]="dropdownDisabled"
            ></thera-dropdown>
          </div>
          <div class="flex flex-row">
            <mat-checkbox class="w-1/3" formControlName="codedr"
              >Code DR</mat-checkbox
            >
            <mat-checkbox class="w-1/3" formControlName="modifiergq"
              >Modifier GQ</mat-checkbox
            >
          </div>
          <div class="flex flex-row pt-4">
            <mat-checkbox class="w-1/3" formControlName="rev780"
              >Rev 780</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
    <div class="flex flex-col w-full">
      <h3 class="mt-7 block font-bold pt-6 text-dark_blue">Modifiers</h3>
      <form [formGroup]="$any(this.payorForm.get('payorOther'))">
        <div class="flex flex-col bg-polar p-7 pb-10 w-full">
          <div class="flex flex-row">
            <mat-checkbox class="w-1/4" formControlName="modifierkx"
              >Modifier KX</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="modified52applies"
              >Modifier 52 Applies</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="modified77applies"
              >Modifier 77 Applies</mat-checkbox
            >
            <mat-checkbox class="w-1/4" formControlName="assistantmodifier"
              >Assistant Modifier Applies</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
  </form>
</entity-management-layout>
